import { render } from "./KillmailTable.vue?vue&type=template&id=4b5ffd27"
import script from "./KillmailTable.vue?vue&type=script&lang=js"
export * from "./KillmailTable.vue?vue&type=script&lang=js"

import "./KillmailTable.vue?vue&type=style&index=0&id=4b5ffd27&lang=css"

import exportComponent from "C:\\Users\\justi\\Code\\vuekillmailtool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__